import { AboutUsTrustpilot } from "modules/sections/AboutUs/AboutUsTrustpilot";
import type { ReactStoryblokComponent } from "types/storyblok";
import type { AboutUsTrustpilotProps } from "modules/sections/AboutUs/AboutUsTrustpilot";

const AboutUsTrustpilotSectionAdapter = ({
  blok: { title, subtitle, srcDesktop, srcMobile, height, alt, cardDesktopPosition },
}: ReactStoryblokComponent<AboutUsTrustpilotProps>) => (
  <AboutUsTrustpilot
    title={title}
    subtitle={subtitle}
    srcDesktop={srcDesktop}
    srcMobile={srcMobile}
    height={height}
    alt={alt}
    cardDesktopPosition={cardDesktopPosition}
  />
);
export default AboutUsTrustpilotSectionAdapter;
